import React, { memo } from 'react';
import { useLangFile } from '../../../../context/LanguageContext';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { ArrowForward } from '@mui/icons-material';

interface NavigateToNextFieldButtonProps {
  onBulkFieldChange: () => void;
  isDisabled: boolean;
}

const NavigateToNextFieldButton: React.FC<NavigateToNextFieldButtonProps> = (
  props: NavigateToNextFieldButtonProps
) => {
  const LangFile = useLangFile();

  return (
    <Tooltip title={LangFile.PrescriptionToolbar.nextField}>
      <Box
        sx={{
          mr: 1,
          ml: 1,
        }}
      >
        <Button
          data-testid="bulk-next-field"
          variant={'contained'}
          color={'primary'}
          onClick={() => props.onBulkFieldChange()}
          disabled={props.isDisabled}
        >
          <ArrowForward />
          <Box
            sx={{
              ml: 1,
            }}
          >
            {LangFile.PrescriptionToolbar.nextField}
          </Box>
        </Button>
      </Box>
    </Tooltip>
  );
};

export default memo(NavigateToNextFieldButton);
